<template>
  <FlotoDrawer :open="showDrawer" @hide="hideDrawer">
    <template v-slot:title> {{ title }} </template>
    <template v-slot:trigger="slotData">
      <slot name="trigger" v-bind="slotData">
        <MButton
          variant="neutral-light"
          class="ml-2"
          @click="showDrawer = true"
        >
          <MIcon name="my-approval" size="lg" class="mx-1" />
          {{ $tc('approval') }} {{ $tc('details') }}
        </MButton>
      </slot>
    </template>
    <ApprovalContainer
      :module-name="$constants.KNOWLEDGE"
      :resource-id="resourceId"
      disabled
    />
  </FlotoDrawer>
</template>

<script>
import ApprovalContainer from '@components/approval/approval-container'
export default {
  name: 'KnowledgeApprovalContainer',
  components: { ApprovalContainer },
  props: {
    resourceId: { type: Number, required: true },
    title: {
      type: String,
      default() {
        return `${this.$tc('approval')} ${this.$tc('details')}`
      },
    },
  },
  data() {
    return {
      showDrawer: false,
    }
  },
  methods: {
    hideDrawer() {
      this.showDrawer = false
    },
  },
}
</script>
